import { Box } from '@stoplight/mosaic'
import { memo } from 'react'

import {
  isNode,
  isGroup,
  isNodeGroup,
  TableOfContentsGroupItem as GroupItem,
} from './index'
import { TableOfContentsGroup } from './TableOfContentsGroup'
import { TableOfContentsNode } from './TableOfContentsNode'

type TableOfContentsGroupItemProps = {
  depth: number
  item: GroupItem
  maxDepthOpenByDefault?: number
  onLinkClick?: () => void
}

const NODE_META_COLOR = {
  get: 'success',
  post: 'primary',
  put: 'warning',
  patch: 'warning',
  delete: 'danger',
}

export const TableOfContentsGroupItem = memo<TableOfContentsGroupItemProps>(
  ({ item, depth, maxDepthOpenByDefault, onLinkClick }) => {
    if (isGroup(item) || isNodeGroup(item)) {
      return (
        <TableOfContentsGroup
          depth={depth}
          item={item}
          maxDepthOpenByDefault={maxDepthOpenByDefault}
          onLinkClick={onLinkClick}
        />
      )
    }

    if (isNode(item)) {
      return (
        <TableOfContentsNode
          depth={depth}
          item={item}
          onLinkClick={onLinkClick}
          meta={
            item.meta && (
              <Box
                // @ts-expect-error
                color={NODE_META_COLOR[item.meta]}
                textTransform="uppercase"
                fontWeight="medium"
              >
                {item.meta}
              </Box>
            )
          }
        />
      )
    }

    return null
  }
)
